module.exports = __webpack_public_path__ + "media/images/emblems/Wallisellen-blazon-f6e6ce8d10e65279aa4ae3294592d9c5.svg";